import { useQuery } from '@tanstack/react-query';
import { IPatientDailyQuestionnaires } from '../types';

export default function useDailyQuestionnairesService(patientUuid: string) {
  const { data, isLoading } = useQuery<{
    result: IPatientDailyQuestionnaires[];
  }>({
    queryKey: [
      patientUuid,
      'daily_questionnaire',
      { name: 'kinomatic' },
    ],
    enabled: !!patientUuid,
  });

  return {
    data: data?.result,
    isLoading: !!patientUuid && isLoading,
  };
}
